export default "dist/images/block-notification-outlined.3db360b.png";